const doc = [({"da":({"js":({"admin":({"bank_accounts":({"create_bank_account":"Opret konto"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;